import { Typography } from "@mui/material";

import { CarrierRoutePointLocationDisplay } from "./components/CarrierRoutePointLocationDisplay";
import { useRoleContext } from "../../../../hooks";
import { toFullReadableAddress } from "../../../../utils";

interface Props {
  routePoint: RoutePoint;
}

export function RoutePointLocationDisplay(props: Props) {
  const { routePoint } = props;
  const { role } = useRoleContext();
  if (role?.type === "CARRIER") {
    return <CarrierRoutePointLocationDisplay routePoint={routePoint} />;
  }
  return (
    <Typography variant="h6">
      {toFullReadableAddress(routePoint.point_location)}
    </Typography>
  );
}
